import { IconType } from '@taxdown/piccolo-web/dist/types/common';
import { history } from 'Store';
import { FRONT_PLANS } from 'Constants/plans';
import { routes } from 'Constants/routes';
import { openUrlInNewNavigator } from 'Utils/links';
import {
  WHATSAPP_ACCOUNT_ASSISTANCE,
  WHATSAPP_OPTIMIZE_NEXT_DECLARATION,
} from 'Constants/whatsappLinks';

export interface ServiceType {
  icon: IconType;
  id: string;
  title: string;
  description: string;
  buttonLabel?: string;
  isAvailable?: () => boolean;
  action?: () => void;
}

export const services: Record<FRONT_PLANS, ServiceType[]> = {
  [FRONT_PLANS.FLEX]: [
    {
      icon: 'IconCalendarM',
      id: 'subscriptionservice_taxreturns',
      title: 'Subscription.Main.Services.Service.1.title',
      description: 'Subscription.Main.Services.Service.1.description',
      buttonLabel: 'Subscription.Main.Services.Service.1.button',
      isAvailable: () => true,
      action: () => history.push(routes.DASHBOARD),
    },
    {
      icon: 'IconCalculatorM',
      id: 'subscriptionservice_taxadvisor',
      title: 'Subscription.Main.Services.Service.2.title',
      description: 'Subscription.Main.Services.Service.2.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.2.button',
      action: () => openUrlInNewNavigator(WHATSAPP_ACCOUNT_ASSISTANCE),
    },
    {
      icon: 'RefreshL',
      id: 'subscriptionservice_procedures',
      title: 'Subscription.Main.Services.Service.4.title',
      description: 'Subscription.Main.Services.Service.4.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.5.button',
      action: () => openUrlInNewNavigator(WHATSAPP_OPTIMIZE_NEXT_DECLARATION),
    },
  ],
  [FRONT_PLANS.PRO]: [
    {
      icon: 'IconCalendarM',
      id: 'subscriptionservice_taxreturns',
      title: 'Subscription.Main.Services.Service.1.title',
      description: 'Subscription.Main.Services.Service.1.description',
      buttonLabel: 'Subscription.Main.Services.Service.1.button',
      isAvailable: () => true,
      action: () => history.push(routes.DASHBOARD),
    },
    {
      icon: 'IconCalculatorM',
      id: 'subscriptionservice_taxadvisor',
      title: 'Subscription.Main.Services.Service.2.title',
      description: 'Subscription.Main.Services.Service.2.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.2.button',
      action: () => openUrlInNewNavigator(WHATSAPP_ACCOUNT_ASSISTANCE),
    },
    {
      icon: 'RefreshL',
      id: 'subscriptionservice_procedures',
      title: 'Subscription.Main.Services.Service.4.title',
      description: 'Subscription.Main.Services.Service.4.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.5.button',
      action: () => openUrlInNewNavigator(WHATSAPP_OPTIMIZE_NEXT_DECLARATION),
    },
  ],
  [FRONT_PLANS.FULL]: [
    {
      icon: 'IconCalendarM',
      id: 'subscriptionservice_taxreturns',
      title: 'Subscription.Main.Services.Service.1.title',
      description: 'Subscription.Main.Services.Service.1.description',
      buttonLabel: 'Subscription.Main.Services.Service.1.button',
      isAvailable: () => true,
      action: () => history.push(routes.DASHBOARD),
    },
    {
      icon: 'IconCalculatorM',
      id: 'subscriptionservice_taxadvisor',
      title: 'Subscription.Main.Services.Service.2.title',
      description: 'Subscription.Main.Services.Service.2.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.2.button',
      action: () => openUrlInNewNavigator(WHATSAPP_ACCOUNT_ASSISTANCE),
    },
    {
      icon: 'SheetL',
      id: 'subscriptionservice_procedures_full',
      title: 'Subscription.Main.Services.Service.3.title',
      description: 'Subscription.Main.Services.Service.3.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.3.button',
      action: () => history.push(routes.PREVIOUS_YEARS_INFO),
    },

    {
      icon: 'RefreshL',
      id: 'subscriptionservice_procedures',
      title: 'Subscription.Main.Services.Service.4.title',
      description: 'Subscription.Main.Services.Service.4.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.5.button',
      action: () => openUrlInNewNavigator(WHATSAPP_OPTIMIZE_NEXT_DECLARATION),
    },
  ],
  [FRONT_PLANS.BASIC]: [
    {
      icon: 'IconCalendarM',
      id: 'subscriptionservice_taxreturns',
      title: 'Subscription.Main.Services.Service.1.title',
      description: 'Subscription.Main.Services.Service.1.description',
      buttonLabel: 'Subscription.Main.Services.Service.1.button',
      isAvailable: () => true,
      action: () => history.push(routes.DASHBOARD),
    },
    {
      icon: 'IconCalculatorM',
      id: 'subscriptionservice_taxadvisor',
      title: 'Subscription.Main.Services.Service.2.title',
      description: 'Subscription.Main.Services.Service.2.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.2.button',
      action: () => history.push(routes.PLANS),
    },
    {
      icon: 'SheetL',
      id: 'subscriptionservice_procedures',
      title: 'Subscription.Main.Services.Service.3.title',
      description: 'Subscription.Main.Services.Service.3.description',
      isAvailable: () => true,
      buttonLabel: 'Subscription.Main.Services.Service.3.button',
      action: () => history.push(routes.PREVIOUS_YEARS_INFO),
    },
  ],
  [FRONT_PLANS.PRO_PLUS]: [],
  [FRONT_PLANS.FULL_PLUS]: [],
  [FRONT_PLANS.FLEX_LITE]: [],
};
